import { useState } from 'react';

import { isMobileOperatingSystem as getIsMobileOperatingSystem } from '@repo/detection';
import { RevampedCheckoutFlowMobile } from '@repo/editor/src/components/UpgradeFlowModal/RevampedCheckoutFlowMobile';
import { withEventScope } from '@repo/event-processor';
import { Modal, ModalProps } from '@repo/ui/deprecated/Modal';

import ChooseTeamPlanFlowContent, {
  INITIAL_DIMENSIONS,
} from './ChooseTeamPlanFlowContent';
import { ChooseTeamPlanFlowModalProps } from './types';

const ChooseTeamPlanFlowModal: React.FC<ChooseTeamPlanFlowModalProps> = (
  props
) => {
  const [dimensions, setDimensions] =
    useState<Pick<ModalProps, 'width' | 'height'>>(INITIAL_DIMENSIONS);

  const shouldShowRevampedMobileCheckoutFlow = getIsMobileOperatingSystem();

  const ChooseTeamPlanFlowModalWrapper = shouldShowRevampedMobileCheckoutFlow
    ? RevampedCheckoutFlowMobile
    : Modal;

  return (
    <ChooseTeamPlanFlowModalWrapper
      {...dimensions}
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <ChooseTeamPlanFlowContent
        {...props}
        onDimensionsChange={setDimensions}
      />
    </ChooseTeamPlanFlowModalWrapper>
  );
};

export default withEventScope(ChooseTeamPlanFlowModal, {
  feature: 'chooseTeamPlanFlow',
});
